import { TooYoung as TooYoungDefault, TooYoungProps } from '../../default/steps';

export const TooYoung: React.VFC<TooYoungProps> = props => {
  return (
    <TooYoungDefault
      {...props}
      title="UpLift only accepts clients who are 18 and above"
      description="We cannot accept clients aged 17 or younger. If you fall into this age group, please contact your school for a referral to a new provider who can support you."
    />
  );
};
